import State from '../core/State';
import { SegmentData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingVisitorsBySegments = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySegments.fetching = draft.visitorsBySegments.fetching + 1;
  });

export const setVisitorsBySegments = (segmentData: SegmentData[]) =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySegments.data = segmentData;
  });

export const finishFetchingVisitorsBySegments = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySegments.fetching = draft.visitorsBySegments.fetching - 1;
  });

export const disposeVisitorsBySegments = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsBySegments.data = initialState.visitorsBySegments.data;
    draft.visitorsBySegments.fetching = initialState.visitorsBySegments.fetching;
  });
